class PreferredSectionExtendedElement extends HTMLElement {
  constructor() {
    super();
    this.jsonfeed = JSON.parse(this.querySelector("#BreadcrumbJSON").textContent)
    this.setCookie('preferred_section', this.jsonfeed.itemListElement[0].item, 400);
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
}
  customElements.define('preferred-section', PreferredSectionExtendedElement);